<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-clipboard-delete`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M33 3a2 2 0 012 2v2h5a2 2 0 012 2v34a2 2 0 01-2 2H8a2 2 0 01-2-2V9a2 2 0 012-2h5V5a2 2 0 012-2h18zm-20 8h-3v30h28V11h-3v2a2 2 0 01-2 2H15a2 2 0 01-2-2v-2zm18 14a1 1 0 011 1v2a1 1 0 01-1 1H17a1 1 0 01-1-1v-2a1 1 0 011-1h14zm0-18H17v4h14V7z"/></svg>
</template>
<script>

export default {
  name: 'IconClipboardDelete',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
